/* Luxe & Gloss bounded product gallery. */
(function () {
  'use strict'

  if (typeof window === 'undefined' || !window.customElements || window.customElements.get('lg-product-gallery')) return

  class LGProductGallery extends HTMLElement {
    connectedCallback () {
      if (this.initialized) return
      this.initialized = true
      this.slides = Array.from(this.querySelectorAll('[data-lg-gallery-media]'))
      this.thumbs = Array.from(this.querySelectorAll('[data-lg-gallery-thumb]'))
      this.counter = this.querySelector('[data-lg-gallery-current]')
      this.dialog = this.querySelector('[data-lg-gallery-dialog]')
      this.dialogImage = this.querySelector('[data-lg-gallery-dialog-image]')
      this.abortController = new AbortController()
      const signal = this.abortController.signal

      if (!this.slides.length) return
      this.index = this.normalizedIndex(Number(this.dataset.initialIndex || 0))
      this.show(this.index)

      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => this.show(Number(thumb.dataset.index)), { signal })
        thumb.addEventListener('keydown', event => this.onThumbKeydown(event), { signal })
      })
      this.querySelector('[data-lg-gallery-previous]')?.addEventListener('click', () => this.show(this.index - 1), { signal })
      this.querySelector('[data-lg-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal })
      this.querySelectorAll('[data-lg-gallery-zoom]').forEach(button => {
        button.addEventListener('click', () => this.openDialog(button), { signal })
      })
      this.querySelector('[data-lg-gallery-close]')?.addEventListener('click', () => this.closeDialog(), { signal })
      this.dialog?.addEventListener('click', event => {
        if (event.target === this.dialog) this.closeDialog()
      }, { signal })
      this.dialog?.addEventListener('close', () => this.dialogTrigger?.focus(), { signal })
      window.addEventListener('kt.product.variant.change', event => this.onVariantChange(event), { signal })
    }

    disconnectedCallback () {
      this.pauseInactiveMedia(-1)
      this.abortController?.abort()
      this.initialized = false
    }

    normalizedIndex (index) {
      if (!this.slides.length) return 0
      return (index + this.slides.length) % this.slides.length
    }

    show (index, focusThumb = false) {
      this.index = this.normalizedIndex(index)
      this.slides.forEach((slide, slideIndex) => {
        slide.toggleAttribute('hidden', slideIndex !== this.index)
      })
      this.thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === this.index
        thumb.setAttribute('aria-selected', String(selected))
        thumb.tabIndex = selected ? 0 : -1
      })
      if (this.counter) this.counter.textContent = String(this.index + 1)
      this.pauseInactiveMedia(this.index)
      if (focusThumb) this.thumbs[this.index]?.focus()
    }

    pauseInactiveMedia (activeIndex) {
      this.slides.forEach((slide, index) => {
        if (index === activeIndex) return
        slide.querySelectorAll('video').forEach(video => video.pause())
      })
    }

    onThumbKeydown (event) {
      let nextIndex
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = this.index + 1
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = this.index - 1
      if (event.key === 'Home') nextIndex = 0
      if (event.key === 'End') nextIndex = this.slides.length - 1
      if (nextIndex === undefined) return
      event.preventDefault()
      this.show(nextIndex, true)
    }

    onVariantChange (event) {
      const variant = event.detail
      if (!variant?.featured_media?.id) return
      const index = this.slides.findIndex(slide => String(slide.dataset.mediaId) === String(variant.featured_media.id))
      if (index >= 0) this.show(index)
    }

    openDialog (button) {
      if (!this.dialog || !this.dialogImage || !button.dataset.zoomSrc) return
      this.dialogTrigger = button
      this.dialogImage.src = button.dataset.zoomSrc
      this.dialogImage.alt = button.dataset.zoomAlt || ''
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal()
      else this.dialog.setAttribute('open', '')
    }

    closeDialog () {
      if (!this.dialog) return
      if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close()
      else {
        this.dialog.removeAttribute('open')
        this.dialogTrigger?.focus()
      }
    }
  }

  window.customElements.define('lg-product-gallery', LGProductGallery)
})()
